import React from "react";
import ReportStatCard from "./ReportStatCard";

const TaxReportCards = ({ data }) => {
  return (
    <>
      <ReportStatCard
        title="Taxable Value"
        value={`₹${data.taxableValue.toLocaleString("en-IN")}`}
        subtitle="Before GST"
        icon="fas fa-file-invoice"
        iconClass="bg-primary"
      />

      <ReportStatCard
        title="Total GST Collected"
        value={`₹${data.totalGstCollected.toLocaleString("en-IN")}`}
        subtitle="Total GST"
        icon="fas fa-percent"
        iconClass="bg-success"
      />

      <ReportStatCard
        title="CGST"
        value={`₹${data.cgst.toLocaleString("en-IN")}`}
        subtitle="Central GST"
        icon="fas fa-landmark"
        iconClass="bg-info"
      />

      <ReportStatCard
        title="SGST"
        value={`₹${data.sgst.toLocaleString("en-IN")}`}
        subtitle="State GST"
        icon="fas fa-building"
        iconClass="bg-warning"
        valueClass="text-dark"
      />

      <ReportStatCard
        title="IGST"
        value={`₹${data.igst.toLocaleString("en-IN")}`}
        subtitle="Integrated GST"
        icon="fas fa-globe"
        iconClass="bg-secondary"
      />

      <ReportStatCard
        title="GST on Shipping"
        value={`₹${data.gstOnShipping.toLocaleString("en-IN")}`}
        subtitle="GST collected on shipping"
        icon="fas fa-truck"
        iconClass="bg-danger"
      />
    </>
  );
};

export default TaxReportCards;